module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1521-1c14d9026e0106cc085b8d38fa377e67.png";